<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Admins') }}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('admin') + $t('saved') : $t('admins') + $t('saved.s')}}</h2>
        </div>
        <b-button class="ph-btn" variant="primary" @click="clickOnCreateBtn">
          {{ $t('Add2') }} {{ $t('a') }} {{ $t('admin') }}  <i class="ph-custom ph-user-plus-fill ml-1"/>
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableAdmin"
          identifier="B122TableAdmin"
          get-b122-table-results-url="/admin/getAdminTableResults"
          :fields="tableFields"
          :editItem=true
          :deleteItem=true
          :empty-title="$t('admin.emptyTitle').toString()"
          :empty-text="$t('admin.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">
          <template #cell(actions)="row">
            <div class="actions-container text-right" v-if="!row.item.role.includes('ROLE_SUPER_ADMIN')">
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(row)">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(row)">
                <i class="ph-custom ph-trash-fill"/>
              </button>
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selectedItem="selectedItem"
      controllerName="admin"
      itemSingularName="admin"
      itemSingularNameUpp="Admin"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'AdminIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    return {
      totalCount: 0,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('admin.lastName'),
          key: 'lastName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('admin.firstName'),
          key: 'firstName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('admin.username'),
          key: 'username',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('admin.phoneNumber'),
          key: 'phoneNumber',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'max-width-cell'
        }
      ]
    }

  },

  methods: {

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'AdminCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'AdminShow',
        params: {
          adminId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'AdminEdit',
        params: {
          adminId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.selectedItem = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.selectedItem = null
      this.$refs.B122TableAdmin.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/AdminIndex.vue